import React from 'react';
import styled from 'styled-components';
import { Container } from '@ui';
import { Body5 } from '@ui';
import { FilterableDocumentsContext } from '@/contexts/FilterableDocumentsContext';
import { convertHexToRGBA, isUndefinedOrNull } from '@utils/usefulFuncs';

const Wrapper = styled.div``;
const TickerWrapper = styled.div`
  padding: 4px 8px;
  border: 1px solid ${({ theme }) => theme.themeColors.text};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.14s;
  min-width: 66px;
  text-align: center;

  &:hover {
    background: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.1)};
    border: 1px solid ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 1)};

    * {
      color: ${({ theme }) => theme.themeColors.primaryCtaButton};
    }
  }

  &.selected {
    border: 1px solid ${({ theme }) => theme.themeColors.primaryCtaButton};
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};

    * {
      color: ${({ theme }) => theme.themeColors.buttonText};
    }
  }
`;
const TickersButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`;

function isDocumentTypeActive(documentType, activeDocumentType) {
  return documentType === activeDocumentType;
}

const DocumentTypeButton = ({ value, activeDocumentType, onClick }) => {
  return (
    <TickerWrapper
      onClick={() => onClick(value)}
      className={isDocumentTypeActive(value, activeDocumentType) ? 'selected' : ''}
    >
      <Body5 bold>{value === 'unknown' || isUndefinedOrNull(value) ? 'Other Materials' : value}</Body5>
    </TickerWrapper>
  );
};

export const DocTypeSelectBar = ({ documentTypes }) => {
  const { applyFilter, clearFilter } = React.useContext(FilterableDocumentsContext);
  const [activeDocumentType, setActiveDocumentType] = React.useState(null);

  const handleDocumentTypeClick = (dt) => {
    if (dt === activeDocumentType) {
      setActiveDocumentType(null);
      clearFilter('doc_type');
      return;
    }

    setActiveDocumentType(dt);
    applyFilter({ doc_type: dt });
  };

  if (documentTypes.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <Container bottom={12}>
        <Body5>Document Types</Body5>
      </Container>
      <TickersButtonWrapper>
        {documentTypes.map((dt) => (
          <DocumentTypeButton
            key={dt}
            value={dt}
            activeDocumentType={activeDocumentType}
            onClick={handleDocumentTypeClick}
          />
        ))}
      </TickersButtonWrapper>
    </Wrapper>
  );
};
